import Vue from 'vue'

// initial state
const state = {
    loadingSpinState: false,//ローディングスピンの状態。
    shortLoadingSpinState: false, //計算以外の処理のローディングスピンの状態
    resultIsKept:false, //計算結果の表示の状態
    searchResultState: false, //機器などの検索結果モーダルの状態
    simpleToDetailIsShow: false, //簡易から詳細に遷移する際のモーダルの状態
}

// getters
const getters = {
    /**
     * ローディングスピンの状態を取得
     */
    modalSpinIsOpen: state =>{
    return state.loadingSpinState
    },
    /**
     * 計算結果の状態を取得
     */
    isResult: state =>{
        return state.resultIsKept
    },
    /**
     * モーダルの状態全体を取得
     */
    getData: state => {
        return state
    }
}

// actions
const actions = {
    /**
     * ローディングスピンを表示する
     */
    spinShow({commit}) {
        commit('update', {loadingSpinState:true})
    },
    /**
     * ローディングスピンを非表示にする
     */
    spinHide({commit}) {
        commit('update', {loadingSpinState:false})
    },
    /**
     * 計算以外の処理でのローディングスピンを表示する
     */   
    shortSpinShow({commit}) {
        commit('update', {shortLoadingSpinState:true})
    },
    /**
     * 計算以外の処理でのローディングスピンを非表示にする
     */
    shortSpinHide({commit}) {
        commit('update', {shortLoadingSpinState:false})
    },
    /**
     * 計算結果を持っていることをstoreに伝える
     */
    haveResult({commit}) {
        commit('update', {resultIsKept:true})
    },
    /**
     * 計算結果を持たないことをstoreに伝える
     */
    resultHide({commit}) {
        commit('update', {resultIsKept:false})
    },
    /**
     * 機器などの検索結果モーダルを表示する
     */
    searchResultShow({commit}) {
        commit('update', {searchResultState:true})
    },
    /**
     * 機器などの検索結果モーダルを非表示にする
     */
    searchResultHide({commit}) {
        commit('update', {searchResultState:false})
    },
    /**
     * 簡易から詳細に遷移する際のモーダルを表示する
     */
    simpleToDetailShow({commit}) {
        commit('update', {simpleToDetailIsShow:true})
    },
    /**
     * 簡易から詳細に遷移する際のモーダルを非表示にする
     */
    simpleToDetailHide({commit}) {
        commit('update', {simpleToDetailIsShow:false})
    },
}

// mutations
const mutations = {
    /**
     * stateの状態を更新する
     * @param {Object} state 
     * @param {Object} data 
     */
    update(state, data){
        Object.keys(data).forEach(key => {
            Vue.set(state, key, data[key])
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}